import { useEffect, useState } from 'react';
import type { SessionResponse } from './ProfileScreen';
import './account-restriction.css';

export function AccountRestrictionNotice() {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    fetch('/api/v1/auth/session', {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.ok ? response.json() as Promise<SessionResponse> : null)
      .then((session) => {
        const isBlocked = session?.authenticated === true && session.user?.status === 'blocked';
        setBlocked(isBlocked);
        document.documentElement.dataset.accountBlocked = isBlocked ? 'true' : 'false';
      })
      .catch(() => {
        setBlocked(false);
        document.documentElement.dataset.accountBlocked = 'false';
      });

    return () => controller.abort();
  }, []);

  if (!blocked) {
    return null;
  }

  return (
    <div className="account-restriction-notice" role="status">
      <strong>Аккаунт ограничен модерацией.</strong>
      <span>
        Публикация контента и действия в Хоппере недоступны. Вы по-прежнему можете просматривать свои данные,
        удалить собственный контент, запросить экспорт или удалить аккаунт.
      </span>
    </div>
  );
}
